this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { 
  syncAlterationProducts(event.cartData, event.source); 
});

function syncAlterationProducts(cart, source) {
  const items = source == 'product-form' ? [cart] : cart.items;
  const alterationProductId = window.theme.alterationProductId;
  if (!alterationProductId) { return; }
  const cartAlterationProduct = items.find(item => item.variant_id == alterationProductId);
  const qty_altered = items
  .filter(item => Object.keys(item.properties).some(key => key.startsWith('Alteration') && item.properties[key].trim() !== ''))
  .reduce((t, i) => t + i.quantity, 0);
  
  if (qty_altered) {
    if (cartAlterationProduct) {
      updateAlterationQty(cartAlterationProduct.id, qty_altered, true);
    } else {
      addAlterationToCart(alterationProductId, qty_altered);
    }
  } else {
    if (cartAlterationProduct) {
      updateAlterationQty(cartAlterationProduct.id, 0, true);
    }
  }
}

function updateAlterationQty(lineItemId, qty, refreshCart, callback = false) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  fetch('/cart/change.js', { 
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({ 
      id: lineItemId.toString(),
      quantity: qty,
      sections: cart.getSectionsToRender().map(section => section.id),
    })
  })
  .then(response => response.json())
  .then(response => { 
    if (refreshCart) { 
      cart.renderContents(response);
    }
    if (callback) { 
      callback();
    }
  })
  .catch(error => { console.error('Error updating item qty in cart:', error) });
}

function addAlterationToCart(productVariantId, quantity) {
  const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  fetch('/cart/add.js', {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      items: [
        {
          quantity: quantity,
          id: productVariantId.toString(),
        },
      ],
      sections: cart.getSectionsToRender().map(section => section.id),
    }),
  })
  .then(response => response.json())
  .then(response => { cart.renderContents(response) })
  .catch(error => { console.error('Error adding product to cart:', error) });
}